import {mapRunningTimeDto} from '@domain/shared'
import {mapTaskRepetitionToTaskRepetitionDto} from '@hconnect/common/mappers'
import {omit} from 'lodash'

import {ShiftEventDto, ShiftEvent} from '../types'
import {isStoppage, isTask} from '../utils/eventType'

export const mapShiftEventDto = (response: ShiftEvent): ShiftEventDto => {
  const baseData = {
    created: response.created.toISOString(),
    lastModified: response.lastModified.toISOString(),
    lastModifiedStatus: response.lastModifiedStatus
      ? response.lastModifiedStatus.toISOString()
      : undefined,
    lastMaintenanceNotificationCreationStart: response.lastMaintenanceNotificationCreationStart
      ? response.lastMaintenanceNotificationCreationStart.toISOString()
      : undefined
  }
  if (isStoppage(response)) {
    return {
      ...response,
      ...baseData,
      stoppageStart: response.stoppageStart.toISOString(),
      stoppageEnd: response.stoppageEnd ? response.stoppageEnd.toISOString() : undefined,
      pxTrendStoppage: response.pxTrendStoppage && mapRunningTimeDto(response.pxTrendStoppage)
    }
  }

  if (isTask(response)) {
    return {
      ...omit(response, ['assignees']),
      ...baseData,
      dueDate: response.dueDate.toISOString(),
      doNotStartBefore: response.doNotStartBefore
        ? response.doNotStartBefore.toISOString()
        : undefined,
      ...('assignees' in response && response.assignees
        ? {assignees: response.assignees}
        : (undefined as never)),
      ...(response.repetitionInfo && {
        repetitionInfo: mapTaskRepetitionToTaskRepetitionDto(response.repetitionInfo)
      })
    }
  }
  return {
    ...response,
    ...baseData,
    schedule: response.schedule?.endDate
      ? {
          startDate: response.schedule.startDate.toISOString(),
          endDate: response.schedule.endDate.toISOString()
        }
      : undefined
  }
}
